import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const BASE_URL = 'https://api.djkdurlach.de/index.php';

const request = async (path, options = {}) => {
  const response = await fetch(`${BASE_URL}${path}`, {
    credentials: 'include',
    ...options,
    headers: {
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result.error || 'Die Anfrage ist fehlgeschlagen.');
  }
  return result;
};

const useSaveMutation = (path, queryKey) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => request(path, {
      method: 'POST',
      body: JSON.stringify(data),
    }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });
};

const useDeleteMutation = (path, queryKey) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => request(`${path}/${id}`, { method: 'DELETE' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });
};

export const useAdminUsers = (enabled) => useQuery({
  queryKey: ['admin-users'],
  queryFn: () => request('/admin/users'),
  enabled,
});

export const useAdminRoles = (enabled) => useQuery({
  queryKey: ['admin-roles'],
  queryFn: () => request('/admin/roles'),
  enabled,
});

export const useSaveAdminUser = () => useSaveMutation('/admin/users', ['admin-users']);
export const useDeleteAdminUser = () => useDeleteMutation('/admin/users', ['admin-users']);
export const useAssignAdminUserRole = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, role_id }) => request(`/admin/users/${id}/role`, {
      method: 'PUT',
      body: JSON.stringify({ role_id }),
    }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-users'] }),
  });
};
export const useSaveAdminRole = () => useSaveMutation('/admin/roles', ['admin-roles']);
export const useDeleteAdminRole = () => useDeleteMutation('/admin/roles', ['admin-roles']);
